import debug from 'debug';
import DictionaryObject from 'Global/Shared/Components/Sitecore/DictionaryObject';
import PriceHelper from 'Minetilbud/Shared/Components/Price/PriceHelper';
import DateHelper from 'Minetilbud/Shared/Components/Date/DateHelper';
import Feature from 'Minetilbud/Shared/Components/feature/feature';
import buyIconSvg from 'Minetilbud/Shared/Icons/icon_online_buy.svg';

const log = debug('InspirationProductsByCategory:Templates');

class Templates {
	constructor() {
		this.dictionary = new DictionaryObject({
			dictionaryUrl: 'Forum_dk/InspirationPages',
			includeDescendants: false
		});
	}

	getImage(product) {
		let aspectRatio = product.aspectRatio;
		if (product.imageWidth === 0 || product.imageHeight === 0) {
			aspectRatio = 0;
		}

		return `<span class="o-inspiration-products__image-loader" data-js="inspiration-products__image-loader" data-aspect-ratio="${aspectRatio}" data-id="${product.id}" data-image-url="${product.imageUrl}" data-title="${product.title}"></span>`;
	}

	/**
	 * If the advert has links defined, return the markup to render info about online shop, otherwise just an empty string
	 * @param {object} item An object describing an advert
	 */
	getOnlineShop(item) {
		if (!item.hasLinks) {
			return ``;
		}

		if(Feature.isEnabled('web-before-price-inspiration-text-feed')) {
			return `
				<button type="button" class="o-inspiration-products__product-feed-button" data-list-event="online-link" data-product-id="${item.id}">
					<span class="o-inspiration-products__product-feed-button-icon">${buyIconSvg}</span>
					<span class="o-inspiration-products__product-feed-button-text">Køb her</span>
				</button>
			`;
		}

		return `
		<span class="mt-shop-button" data-id="${item.id}">
			<span class="mt-shop-button__icon">${buyIconSvg}</span>
			<span class="mt-shop-button__text">${item.linkButtonText}</span>
		</span>`
	}

	/**
	 * Return the title, truncated to max 24 characters
	 * 
	 * @param {object} item An object representation for an advert
	 */
	getProductName(item) {
		const title = item.title.substr(0, 24);
		const suffix = item.title.length > title.length ? '...' : '';

		return `<span class="o-inspiration-products__product">${title}${suffix}</span>`;
	}

	/**
	 * @returns {Promise}
	 */
	async initDictionary() {
		return this.dictionary.Get();
	}

	price({ isMinimumPrice, price }) {
		if (price === 0) return '<div class="o-inspiration-products__price"></div>';

		const priceHelper = new PriceHelper();
		const priceType = isMinimumPrice ? 'fra' : 'kr.';
		const formattedPrice = priceHelper.Format(price);

		if(Feature.isEnabled('web-before-price-inspiration-text-feed')) {
			return `<div class="o-inspiration-products__price">${priceType} ${formattedPrice}</div>`;
		}

		return `<div class="o-inspiration-products__price">${formattedPrice}</div>`;
	}

	/**
	 * @param {Object} options
	 * @param {number} options.priceBefore
	 */
	priceBefore({ priceBefore }) {
		if (priceBefore !==  undefined && priceBefore !== null) {
			const priceHelper = new PriceHelper();
			const formattedPrice = priceHelper.Format(priceBefore);

			return `<div class="o-inspiration-products__price-before">${this.dictionary.Text('beforePrice')} ${formattedPrice}</div>`;
		}

		if (Feature.isEnabled('web-force-before-price')) {
			return `<div class="o-inspiration-products__price-before">${this.dictionary.Text('beforePrice')} 1985,-</div>`;
		}

		return `<div class="o-inspiration-products__price-before"></div>`;
	}

	/**
	 * @param {Object} options
	 * @param {number} options.price
	 * @param {number} options.savings
	 */
	priceSavingsSplash({ price, savings }) {
		if (savings > 0 || Feature.isEnabled('web-force-before-price')) {
			return `<div class="o-inspiration-products__price-savings-splash">spar ${savings === 0 && Feature.isEnabled('web-force-before-price') ? 38 : Math.floor(savings) }%</div>`;
		}

		return '';
	}

	/**
	 * @param {Object} product
	 */
	product(product) {
		const dateHelper = new DateHelper();
		const validDate = product.showDate ? dateHelper.Format(product.validFrom) + '-' + dateHelper.Format(product.validTo) : '';

		if(Feature.isEnabled('web-before-price-inspiration-text-feed')) {
			return `
				<li class="o-inspiration-products__item">
					${this.priceSavingsSplash({ price: product.price, savings: product.pricePercentage })}
					<a href="${product.advertUrl}" class="o-inspiration-products__link">
						<div class="o-inspiration-products__image-wrapper">
							${this.getImage(product)}
						</div>
						${this.title(product)}
						${this.price({ isMinimumPrice: product.isMinimumPrice, price: product.price })}
						${this.priceBefore({ priceBefore: product.priceBefore })}
						<div class="o-inspiration-products__valid-date">${validDate}</div>		
						<div class="o-inspiration-products__customer-name">${product.customerName}</div>
						${this.getOnlineShop(product)}
					</a>
				</li>
			`;
		}

		return `
			<li class="o-inspiration-products__item">
				<div class="mt-aderts__item-wrapper">
					<a href="${product.advertUrl}" class="o-inspiration-products__link">
						<div class="o-inspiration-products__image-wrapper">
							${this.getImage(product)}
						</div>
						<div class="o-inspiration-products__content">
							<div class="o-inspiration-products__valid-date">${validDate}</div>
							<div class="o-inspiration-products__customer-name">${product.customerName}</div>
							${this.title(product)}
							${this.price({ isMinimumPrice: product.isMinimumPrice, price: product.price })}
						</div>
						${this.getOnlineShop(product)}
					</a>
				</div>
			</li>
		`;
	}

	/**
	 * Return the title, truncated to max 24 characters
	 * 
	 * @param {object} item An object representation for an advert
	 */
	title(item) {
		const title = item.title.substr(0, 24);
		const suffix = item.title.length > title.length ? '...' : '';

		return `<div class="o-inspiration-products__title">${title}${suffix}</div>`;
	}
}

export default Templates;
